import { createBusinessApi } from '@platform/billing';
import { apiClient } from '@/shared/api/client';

/**
 * billing-service 조직 축 호출부.
 * 실제 구현(엔드포인트·응답 타입)의 SSOT 는 `@platform/billing` — console-web 과 공유한다.
 * 여기서는 이 앱의 apiClient 인스턴스만 주입한다.
 */
export const businessApi = createBusinessApi(apiClient);
